import React, { useState } from 'react';

import LinearProgress from '@mui/material/LinearProgress';

import { getTenantFromUrl } from '../../utils/tenant';
import SignupFlow from './SignUpFlow';
import InitioMovedAnnouncement from './InitioMovedAnnouncement';

import './SignUp.scss';

export default function Signup() {
  const [currentStep, setCurrentStep] = useState(1);
  const isInitioTenant = getTenantFromUrl() === 'initio';

  if (isInitioTenant) {
    return (
      <main className="Signup Signup--initio-closed">
        <InitioMovedAnnouncement />
      </main>
    );
  }

  return (
    <main className="Signup">
      <h4>Sign up</h4>
      <span className="current-step">{`${currentStep} of 3`}</span>
      <LinearProgress variant="determinate" value={(currentStep / 3) * 100} />
      <SignupFlow currentStep={currentStep} setCurrentStep={setCurrentStep} />
    </main>
  );
}
